<template>
  <div class="pop-room">
    <a
      href="javascript:;"
      @click="closeApproval()"
      class="iconfont icon-close"
    ></a>
    <div class="pop-cont">
      <el-col :span="22">
        <el-form
          ref="form"
          :model="form"
          label-width="120px"
          class="approval-form"
        >
          <el-form-item label="意见与建议">
            <el-input
              type="textarea"
              placeholder="请输入审批意见或建议"
              :autosize="{ minRows: 4, maxRows: 6 }"
              size="small"
              v-model="form.remark"
            ></el-input>
          </el-form-item>
          <el-form-item label="审核结果">
            <el-radio v-model="form.approvalResult" label="1"
              >同意执行</el-radio
            >
            <el-radio v-model="form.approvalResult" label="0"
              >拒绝执行</el-radio
            >
          </el-form-item>

          <!-- 新审批、且是战略企划部，选择实施类别 -->
          <el-form-item
            v-if="approvalRow.flow.edition == '2' && form.approvalResult == '1' && isZLQHB()"
            label="实施类别"
          >
            <el-radio v-model="form2.sslb" label="I类">I类</el-radio>
            <el-radio v-model="form2.sslb" label="II类">II类</el-radio>
            <el-radio v-model="form2.sslb" label="III类">III类</el-radio>
          </el-form-item>

          <el-form-item label="">
            <el-button
              @click="createApproval()"
              :loading="isSubmit"
              class="form-btn"
              type="success"
              >确认提交审批</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      form: {
        flowApprovalId: "",
        approvalType: 0,
        remark: "",
        approvalResult: "1",
      },
      form2: {
        applyId: 0,
        // I类、II类、III类，默认III类
        sslb: "III类",
      },
      isSubmit: false,
    };
  },
  computed: {
    ...mapState({
      userData: (state) => state.main.userData,
      approvalRow: (state) => state.main.approval_row,
      approvalId: (state) => state.main.approvalId,
      approvalType: (state) => state.main.approvalType,
    }),
  },
  mounted() {
    this.form.flowApprovalId = this.approvalId;
    this.form.approvalType = this.approvalType;
    this.form2.applyId = this.approvalRow.flow.applyId;

    console.log(this.approvalRow);
  },
  methods: {
    isZLQHB() {
      // 判断当前是否是战略企划部在审批，且是申请表，填写选择实施级别// I类、II类、III类
      let _zlqhb_user;
      let _flow = this.approvalRow.flow;

      if (this.approvalRow.wxType == "A" || this.approvalRow.wxType == "B") {
        // 微型项目不需要选择实施级别
        return false;
      } else if (this.approvalRow.flow.pType == 2) {
        // 一般项目-其他需求
        return false;
      }

      if (_flow.flowsource == "2") {
        // 申请表
        switch (_flow.flowsourceType) {
          case "0":
            _zlqhb_user = _flow.approvals[2];
            break;
          case "1":
            _zlqhb_user = _flow.approvals[3];
            break;
          case "2":
            _zlqhb_user = _flow.approvals[2];
            break;
          case "3":
            _zlqhb_user = _flow.approvals[4];
            // 微型项目不需要选择实施级别
            return false;
            break;
          case "4":
            _zlqhb_user = _flow.approvals[5];
            // 微型项目不需要选择实施级别
            return false;
            break;
          case "5":
            _zlqhb_user = _flow.approvals[1];
            break;
        }
      }
      return (
        _zlqhb_user &&
        _zlqhb_user.user &&
        _zlqhb_user.user.id == this.userData.id
      );
    },
    createApproval() {
      if (this.form.approvalResult == 0 && this.form.remark == "") {
        this.$message.error("请输入拒绝理由或修改意见等");
        return false;
      }

      this.isSubmit = true;
      ajax.post("/user/flow/approval", this.form, (res) => {
        this.$message.success("提交审批成功");
        this.$store.commit("set_approvalSuccess", true);
        this.$store.commit("set_approvalId", 0);

        this.getTipsNum();

        if (this.isZLQHB()) {
          // 修改实施类别
          ajax.post("/gc/project/apply/sslb/edit", this.form2, (res) => {
            this.isSubmit = false;
          });
        }
      });
    },
    // 获取最新的会议条数及审批条数
    getTipsNum() {
      ajax.get("/msg/tips/num", "", (res) => {
        this.tipNum = res.vo;
        this.$store.commit("set_tipNum", this.tipNum);
      });
    },
    closeApproval() {
      this.$store.commit("set_approvalId", 0);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Approval.vue